import { render } from "./Artworks.vue?vue&type=template&id=7d1afabf&scoped=true"
import script from "./Artworks.vue?vue&type=script&lang=js"
export * from "./Artworks.vue?vue&type=script&lang=js"

import "./Artworks.vue?vue&type=style&index=0&id=7d1afabf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d1afabf"]])

export default __exports__